import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { BackButton, LoadingState } from '../components/common';
import { Heading, Text } from '../components/common/Typography';
import { Card } from '../components/common/Card';
import { navigateBack } from '../utils/navigationUtils';
import { useClubPermissions } from '../hooks/useClubPermissions';
import { ClubLeagueSquadSection } from '../components/clubs/dashboard/ClubLeagueSquadPanel';
import { APP_PAGE_BLEED_ROOT, APP_PAGE_GUTTER } from '../utils/sessionMobileLayout';

const ClubLeagueSquadPage = ({ currentUser }) => {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    club: selectedClub,
    role: userClubRole,
    loading: clubLoading,
    hasPermission,
    error: clubError,
  } = useClubPermissions(clubId, currentUser);

  const canManage = ['owner', 'admin', 'host'].includes(userClubRole)
    || currentUser?.role === 'admin'
    || currentUser?.role === 'super_admin';

  if (clubLoading) {
    return (
      <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
        <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} py-12`}>
          <LoadingState message="Loading league squad…" />
        </div>
      </div>
    );
  }

  if (clubError || !hasPermission || !canManage) {
    return (
      <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
        <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} py-12`}>
          <Card variant="default" size="large" className="text-center py-12">
            <Heading level={2} className="mb-4">Access Denied</Heading>
            <Text className="text-text-secondary">
              {clubError || 'Only club hosts, admins, and owners can link county league players.'}
            </Text>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className={`${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`}>
      <div className={`mx-auto max-w-app-shell ${APP_PAGE_GUTTER} pt-3 pb-8 md:pt-6`}>
        <div className="mb-6">
          <BackButton
            onClick={() => navigateBack(navigate, location, clubId, `/club-management/${clubId}`)}
          >
            Back to Club Management
          </BackButton>
          <Heading level={1} className="mt-3 text-xl font-bold text-text-primary sm:text-2xl">
            League squad
          </Heading>
          <Text className="mt-1 text-sm text-text-secondary">
            {selectedClub?.name
              ? `Connect ${selectedClub.name} to Middlesex, then link player names`
              : 'Connect this club to Middlesex, then link player names'}
          </Text>
        </div>

        <ClubLeagueSquadSection clubId={clubId} />
      </div>
    </div>
  );
};

export default ClubLeagueSquadPage;
